import './ActivityResultStates.scss';

import * as React from 'react';

import { Pending } from '~teacher/components/ExportReports/ExportFeedback/ExportFeedbackIcons';

export const ActivityResultLoading = () => (
  <div
    data-testid="activity-result-loading"
    className="flex items-center justify-center w-full activity-result-states-container"
  >
    <Pending />
  </div>
);
